import React, { PureComponent } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { useStore } from '../../../store';
import LoadingButton from '../../../facturotopia/LoadingButton';

class SociosDeNegocioItemActions extends PureComponent {
  suspend = async () => {
    const { selectedRows } = this.props;
    const socios = selectedRows[0];

    await this.props.upsert(
      {
        status: 0,
      },
      socios.id
    );

    await this.props.paginate();
  };

  activate = async () => {
    const { selectedRows } = this.props;
    const socios = selectedRows[0];

    await this.props.upsert(
      {
        status: 1,
      },
      socios.id
    );

    await this.props.paginate();
  };

  invite = async () => {};

  render() {
    const { selectedRows, selectedRowKeys, busy } = this.props;

    if (busy) {
      return (
        <LoadingButton
          loading={busy}
          variant="secondary"
        >
          Procesando
        </LoadingButton>
      );
    }

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={false}
      >
        <Dropdown.Toggle
          variant="secondary"
          id="dropdown-basic"
        >
          Acciones{' '}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {selectedRowKeys.length === 1 &&
            [0, 2].indexOf(selectedRows[0].status) !== -1 &&
            Guardian.allows('socios.negocio.activar') && (
              <Dropdown.Item
                as="div"
                onClick={this.activate}
              >
                Activar
              </Dropdown.Item>
            )}

          {selectedRowKeys.length === 1 && Guardian.allows('socios.negocio.reenviar.invitacion') && (
            <Dropdown.Item
              as="div"
              onClick={this.invite}
            >
              Reenviar invitación
            </Dropdown.Item>
          )}

          {selectedRowKeys.length === 1 && <Dropdown.Divider />}

          {selectedRowKeys.length >= 1 && Guardian.allows('socios.negocio.suspender') && (
            <Dropdown.Item
              as="div"
              onClick={this.suspend}
            >
              Dar de baja
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.modulo.socios.upsert,
    socios: state.modulo.socios.list.data,
  };
};

const mapActions = (actions) => {
  return {
    ...actions.modulo.socios.upsert,
    paginate: actions.modulo.socios.list.paginate,
  };
};

export default connect(useStore, mapState, mapActions)(SociosDeNegocioItemActions);
